import {
	ApiPermissionsMap,
	GET_DEFAULT_API_PERMISSIONS_MAP,
	getApiPermissionsMapFactory,
} from '../../../xlink/configs/ApiPermissionsMap';
import { AuditsPermissions } from '../../../xlink/modules/Audits/Services/AuditsPermissions';
import {
	ChallengesPermissions,
} from '../../../xlink/modules/Challenges/Services/ChallengesPermissions';
import {
	CollectionsPermissions,
} from '../../../xlink/modules/Collections/Services/CollectionsPermissions';
import { EventsPermissions } from '../../../xlink/modules/Events/Services/EventsPermissions';
import { NewsPermissions } from '../../../xlink/modules/News/Services/NewsPermissions';
import { OffersPermissions } from '../../../xlink/modules/Offers/Services/OffersPermissions';
import {
	QuizzesPermissions,
} from '../../../xlink/modules/Quizzes/Services/QuizzesPermissions';
import {
	SurveysPermissions,
} from '../../../xlink/modules/Surveys/Services/SurveysPermissions';
import { VideosPermissions } from '../../../xlink/modules/Videos/Services/VideosPermissions';
import {
	getPermissionTabsFactory,
} from '../../../xlink/services/permissions/PermissionsTabs';
import { OxylinkConstants } from '../OxylinkConstants';

export class OxylinkPermissionsConfig {

	public static getApiPermissionsMap = (): ApiPermissionsMap => ({
		...GET_DEFAULT_API_PERMISSIONS_MAP(),
		[OffersPermissions.OFFERS_KEY]: OxylinkConstants.OFFERS_API_PERMISSIONS_NAME,
	});

	public static getPermissionTabs = () => [
		OffersPermissions.getOffersTab(),
		NewsPermissions.getNewsTab(),
		EventsPermissions.getEventsTab(),
		SurveysPermissions.getSurveysTab(),
		VideosPermissions.getVideosTab(),
		QuizzesPermissions.getQuizzesTab(),
		ChallengesPermissions.getChallengesTab(),
		CollectionsPermissions.getCollectionsTab(),
		AuditsPermissions.getAuditsTab(),
	];

	public static getPermissionTabHashes = () => [
		OffersPermissions.OFFERS_TAB_HASH,
		NewsPermissions.NEWS_TAB_HASH,
		EventsPermissions.EVENTS_TAB_HASH,
		SurveysPermissions.SURVEYS_TAB_HASH,
		VideosPermissions.VIDEOS_TAB_HASH,
		QuizzesPermissions.QUIZZES_TAB_HASH,
		ChallengesPermissions.CHALLENGES_TAB_HASH,
		CollectionsPermissions.COLLECTIONS_TAB_HASH,
		AuditsPermissions.AUDITS_TAB_HASH,
	];

	public static initPermissionsConfig = () => {
		getPermissionTabsFactory.register('**', OxylinkPermissionsConfig.getPermissionTabs);
		getApiPermissionsMapFactory.register('**', OxylinkPermissionsConfig.getApiPermissionsMap);
	};
}
